import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  House, MagnifyingGlass, FileText, Users, Gauge, GearSix, SignOut, Sparkle, ChartBar,
  Question, Buildings, Bell, Globe
} from "@phosphor-icons/react";
import { auth, api } from "../lib/api";
import { useEffect, useState } from "react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: House, testid: "nav-dashboard" },
  { to: "/scouting", label: "Scouting Gare", icon: MagnifyingGlass, testid: "nav-scouting" },
  { to: "/eu-tenders", label: "Gare Europee", icon: Globe, testid: "nav-eu" },
  { to: "/decisions", label: "Bid / No-Bid", icon: Gauge, testid: "nav-decisions" },
  { to: "/partners", label: "Partner & ATI", icon: Users, testid: "nav-partners" },
  { to: "/procedures", label: "Procedure", icon: FileText, testid: "nav-procedures" },
  { to: "/analytics", label: "Analytics", icon: ChartBar, testid: "nav-analytics" },
];

const ADMIN_NAV = [
  { to: "/admin/portals", label: "Admin Portali", icon: Buildings, testid: "nav-admin-portals" },
  { to: "/faq", label: "Aiuto & FAQ", icon: Question, testid: "nav-help" },
];

export default function Sidebar() {
  const loc = useLocation();
  const nav = useNavigate();
  const user = auth.getUser();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const fetchN = () => {
      api.get("/notifications?unread=true").then(({ data }) => setUnread(data.length)).catch(() => {});
    };
    fetchN();
    const t = setInterval(fetchN, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <aside className="w-64 bg-zinc-950 text-zinc-100 flex flex-col h-screen sticky top-0" data-testid="sidebar">
      <Link to="/welcome" className="p-6 border-b border-zinc-800 block hover:bg-zinc-900 transition-colors" data-testid="sidebar-logo">
        <div className="flex items-center gap-2">
          <Sparkle weight="fill" className="text-klein" size={24} />
          <div>
            <div className="font-display font-extrabold text-lg tracking-tight">GARE MANAGER</div>
            <div className="label-up text-klein">AI / D.Lgs. 36/2023</div>
          </div>
        </div>
      </Link>

      <nav className="flex-1 py-4 space-y-1 px-3 overflow-y-auto">
        {NAV.map((n) => {
          const active = loc.pathname.startsWith(n.to);
          const Icon = n.icon;
          return (
            <Link key={n.to} to={n.to} data-testid={n.testid}
              className={`flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-sm transition-all ${
                active ? "bg-klein text-white" : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
              }`}>
              <Icon size={18} weight={active ? "fill" : "regular"} />
              {n.label}
            </Link>
          );
        })}

        <div className="pt-4 mt-4 border-t border-zinc-800">
          <div className="label-up text-zinc-600 px-3 mb-2">Sistema</div>
          {ADMIN_NAV.map((n) => {
            const active = loc.pathname.startsWith(n.to);
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={n.testid}
                className={`flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-sm transition-all ${
                  active ? "bg-klein text-white" : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
                }`}>
                <Icon size={18} weight={active ? "fill" : "regular"} />
                {n.label}
              </Link>
            );
          })}
          <button onClick={() => nav("/notifications")} className="w-full flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-sm text-zinc-400 hover:bg-zinc-900 hover:text-white transition-all" data-testid="nav-notifications">
            <Bell size={18} />
            <span className="flex-1 text-left">Notifiche</span>
            {unread > 0 && <span className="bg-signal text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">{unread}</span>}
          </button>
        </div>
      </nav>

      <div className="border-t border-zinc-800 p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 bg-klein rounded-sm flex items-center justify-center font-display font-bold text-sm">
            {user?.name?.slice(0, 2).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          </div>
        </div>
        <button data-testid="btn-logout" onClick={() => { auth.clear(); nav("/login"); }}
          className="w-full flex items-center gap-2 px-3 py-2 text-xs text-zinc-400 hover:bg-zinc-900 hover:text-white rounded-sm transition-colors">
          <SignOut size={16} /> Esci
        </button>
      </div>
    </aside>
  );
}
